import type { ActivityType } from '@movmania/core'
import { ACTIVITY_ICONS, ICON_STROKE } from '../lib/icons.js'
import { useT } from '../lib/useT.js'

/**
 * Tuile de sélection d'activité. Factorisée parce qu'elle apparaît dans trois
 * écrans (inscription, saisie, profil) et qu'une divergence entre eux est
 * exactement ce qui a produit le débordement de « RENFORCEMENT ».
 */
export function ActivityTile({
  type,
  selected,
  onClick,
}: {
  type: ActivityType
  selected: boolean
  onClick: () => void
}) {
  const t = useT()
  const Icon = ACTIVITY_ICONS[type]
  return (
    <button
      onClick={onClick}
      aria-pressed={selected}
      // Le nom complet reste accessible au lecteur d'écran même si la tuile
      // n'affiche que la forme courte.
      aria-label={t(`activityType.${type}`)}
      className={`press flex min-h-22 min-w-0 flex-col items-center justify-center gap-2 rounded-[var(--radius-tile)] px-1 py-3 ${
        selected ? 'bg-green text-surface' : 'bg-surface text-ink-2 shadow-[var(--shadow-soft)]'
      }`}
    >
      <Icon size={22} strokeWidth={ICON_STROKE} aria-hidden="true" />
      <span className="text-caption w-full truncate text-center font-semibold">
        {t(`activityTypeShort.${type}`)}
      </span>
    </button>
  )
}

export function ActivityTileGrid({
  types,
  isSelected,
  onToggle,
}: {
  types: readonly ActivityType[]
  isSelected: (type: ActivityType) => boolean
  onToggle: (type: ActivityType) => void
}) {
  return (
    <div className="grid grid-cols-4 gap-2">
      {types.map((type) => (
        <ActivityTile
          key={type}
          type={type}
          selected={isSelected(type)}
          onClick={() => onToggle(type)}
        />
      ))}
    </div>
  )
}
